import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-374728f3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "E808B2RenderContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ", -1));
const _hoisted_3 = {
  class: "ft20"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "观察相邻两图三角形的边的颜色，全不同涂0，一个相同涂1，三个相同涂3；", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "再观察相邻两图的符号形状，全不同涂0，一个相同涂1，三个相同涂3；", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "边的颜色在上，符号的形状在下。", -1));
const _hoisted_7 = {
  key: 0,
  class: "opd10"
};
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center flex flex-col"
};
const _hoisted_9 = {
  key: 0,
  class: "mt8 ft14"
};
const _hoisted_10 = {
  key: 0,
  class: "opd10"
};
const _hoisted_11 = {
  key: 0,
  class: "bothCenter flex flex-col"
};
const _hoisted_12 = {
  key: 0,
  class: "mt8 ft14"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_row = _resolveComponent("el-row");
  const _component_E808B2Triangle = _resolveComponent("E808B2Triangle");
  const _component_E808B2BtnGroup = _resolveComponent("E808B2BtnGroup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex items-center justify-center"
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, "第" + _toDisplayString((($props.data[$props.data.length - 1].questionIndex + 1) / 12).toFixed(0)) + "组", 1)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 8,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [$props.reviewMode ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        style: {
          "background": "#1388ff",
          "color": "white"
        },
        class: "ptr opd6 brd4",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, "结束回看")) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_4, _hoisted_5, _hoisted_6]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, (q, qi) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: `1_e808b2_${q.questionIndex}`
      }, [qi < 6 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_E808B2Triangle, {
        colors: q.question
      }, null, 8, ["colors"])])) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  }), (_openBlock(), _createBlock(_component_el_row, {
    class: "flex items-center justify-center",
    key: `1_e808b2_btns_${$props.data[0].questionIndex}`
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, (q, qi) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: `1_e808b2_btn_${q.questionIndex}`
      }, [qi < 5 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_E808B2BtnGroup, {
        onAnswer: v => $options.onAnswer(q.questionIndex, v),
        review: $props.review ? $props.review[q.questionIndex]?.answer : null
      }, null, 8, ["onAnswer", "review"]), $props.review ? (_openBlock(), _createElementBlock("span", _hoisted_9, "正确答案: " + _toDisplayString(q.rightAnswer), 1)) : _createCommentVNode("", true), $props.review && $props.review[q.questionIndex] ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        style: _normalizeStyle({
          color: $props.review[q.questionIndex].result ? 'green' : 'red'
        }),
        class: "ft14"
      }, "您的答案: " + _toDisplayString($props.review[q.questionIndex].answer), 5)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  })), _createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, (q, qi) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: `2_e808b2_${q.questionIndex}`
      }, [qi >= 5 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_E808B2Triangle, {
        colors: q.question
      }, null, 8, ["colors"])])) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  }), (_openBlock(), _createBlock(_component_el_row, {
    class: "flex items-center justify-center",
    key: `2_e808b2_btns_${$props.data[0].questionIndex}`
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data, (q, qi) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: `2_e808b2_btn_${q.questionIndex}`
      }, [qi >= 5 && qi < 11 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_E808B2BtnGroup, {
        onAnswer: v => $options.onAnswer(q.questionIndex, v),
        review: $props.review ? $props.review[q.questionIndex]?.answer : null
      }, null, 8, ["onAnswer", "review"]), $props.review ? (_openBlock(), _createElementBlock("span", _hoisted_12, "正确答案: " + _toDisplayString(q.rightAnswer), 1)) : _createCommentVNode("", true), $props.review && $props.review[q.questionIndex] ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        style: _normalizeStyle({
          color: $props.review[q.questionIndex].result ? 'green' : 'red'
        }),
        class: "ft14"
      }, "您的答案: " + _toDisplayString($props.review[q.questionIndex].answer), 5)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  }))]);
}